<template>
  <div ref="canvas_side"
       class="canvas_side">
    <canvas :id="id"
            @mousedown="onCanvasMouseDown"
            @mouseup="onCanvasMouseUp"
            @mousemove="onCanvasMouseMove"
            @mouseout="onCanvasMouseOut"
            ref="canvas"></canvas>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'cv',
  data () {
    return {
      pjImg: null,
      canvas: null,
      context: null,
      proportion: 1,
      cvX: 0,
      cvY: 0,
      screen: {
        calX: 0,
        calY: 0
      },
      selectedRect: null,
      isDragging: false,
      isMouseInCanvas: false,
      // oldPosition: {
      //   x: 0,
      //   y: 0
      // },
      moveTime: 0,
      outRoomHeight: 0,
      outRoomWidth: 0
    }
  },
  props: [
    'id',
    'w',
    'h',
    'pjRect',
    'roomRect',
    'arrDashLines',
    'arrDashRemainLines',
    'arrOffsetLines',
    'arrRectLines',
    'arrLightingArea',
    'avlRect',
    'arrHelpLines',
    'arrHelpText',
    'arrCatchArea',
    'arrBlackArea',
    'arrRectHorSecLines',
    'arrowRects',
    'arrCurveRect',
    'arrQuickCornerLines',
    'arrRectArea',
    'arrCornerCorAreas'
  ],
  computed: {
    ...mapState([
      'pjImgType',
      'graph',
      'houseInfo',
      'projectorChecked',
      'screenMoveChecked',
      'throwDistanceChecked',
      'screenSizeChecked',
      'drawData',
      'centerPositionInit',
      'vLensShiftNow',
      'hLensShiftNow',
      'initScreenSize',
      'projectorCheckedSide',
      'projectorCheckedTop',
      'flToB',
      'flToL',
      'offset',
      'selectedModelData',
      'vAngle',
      'hAngle',
      'selectedLensData',
      'position',
      'blackDrawData',
      'curveRadius',
      'curveDepth',
      'curveShape',
      'curveDirection',
      'limitData',
      'focusView',
      'aspectRatio',
      'isUSTWall',
      'isOutOfSpec',
      'realThrowDistanceChecked',
      'searchTabActive',
      'floorFootProjectorChecked'
    ]),
    throw_distance_checked: {
      get () {
        return this.throwDistanceChecked
      }
    },
    floor_footProjector_checked: {
      get () {
        return this.floorFootProjectorChecked
      }
    },
    screen_size_checked: {
      get () {
        return this.screenSizeChecked
      }
    },
    pjRectOnCanvas: {
      get () {
        return this.pjRectToCanvas()
      }
    },
    roomRectOnCanvas: {
      get () {
        return this.roomRectToCanvas()
      }
    },
    avlRectOnCanvas: {
      get () {
        return this.avlRectToCanvas()
      }
    },
    arrRectLinesOnCanvas: {
      get () {
        return this.arrRectLinesToCanvas()
      }
    },
    arrLightingAreaOnCanvas: {
      get () {
        return this.arrLightingAreaToCanvas()
      }
    },
    arrCatchAreaOnCanvas: {
      get () {
        return this.arrCatchAreaToCanvas()
      }
    },
    arrBlackAreaOnCanvas: {
      get () {
        if (this.arrBlackArea) {
          return this.arrBlackAreaToCanvas()
        }
      }
    },
    arrDashLinesOnCanvas: {
      get () {
        return this.arrDashLinesToCanvas()
      }
    },
    arrDashRemainLinesOnCanvas: {
      get () {
        return this.arrDashRemainLinesToCanvas()
      }
    },
    arrOffsetLinesOnCanvas: {
      get () {
        return this.arrOffsetLinesToCanvas()
      }
    },
    arrHelpLinesOnCanvas: {
      get () {
        return this.arrHelpLinesToCanvas()
      }
    },
    arrQuickCornerLinesOnCanvas: {
      get () {
        return this.arrQuickCornerLinesToCanvas()
      }
    },
    arrCornerCorAreasOnCanvas: {
      get () {
        return this.arrCornerCorAreasToCanvas()
      }
    },
    arrHelpTextOnCanvas: {
      get () {
        return this.arrHelpTextToCanvas()
      }
    },
    arrRectHorSecLinesOnCanvas: {
      get () {
        return this.arrRectHorSecLinesToCanvas()
      }
    },
    arrowRectsOnCanvas: {
      get () {
        return this.arrowRectsToCanvas()
      }
    },
    arrCurveRectOnCanvas: {
      get () {
        return this.arrCurveRectToCanvas()
      }
    },
    arrRectAreaOnCanvas: {
      get () {
        return this.arrRectAreaToCanvas()
      }
    }
  },
  watch: {
    curveDirection (newValue, oldValue) {
      this.onHouseInfoChanged()
    },
    curveDepth (newValue, oldValue) {
      this.onHouseInfoChanged()
    },
    pjImgType: function () {
      this.pjImg.src = this.$commonJs.getPjImgUrl(this.id, this.pjImgType, this.selectedLensData)
    },
    position: {
      handler (newValue, oldValue) {
        this.pjImg.src = this.$commonJs.getPjImgUrl(this.id, this.pjImgType, this.selectedLensData)
      },
      deep: true
    },

    selectedLensData (newValue, oldValue) {
      this.pjImg.src = this.$commonJs.getPjImgUrl(this.id, this.pjImgType, newValue)
    }
  },
  created () {
    this.pjImg = new Image()
  },
  mounted () {
    this.canvas = this.$refs.canvas
    this.context = this.canvas.getContext('2d')
    this.initPjImg()
    window.addEventListener('keydown', this.handleKeyDown, false)
    window.addEventListener('keyup', this.handelKeyUp, false)
  },
  methods: {
    ...mapMutations([
      'PJX',
      'PJY',
      'PJZ',
      'SCRNW',
      'SCRNH',
      'SCREENSIZE',
      'SET_HLENSSHIFT',
      'SET_VLENSSHIFT',
      'VLENSSHIFT',
      'SET_TEMVLENSSHIFT',
      'SET_GRAPH_ROOMD',
      'SET_GRAPH_ROOMH',
      'SET_GRAPH_ROOMW'
    ]),
    // 移动pjy时进行的校验
    checkMovePjy (y) {
      // 根据最大最小尺寸获取距离
      let minMaxD = this.$commonViewJs.getMinDisByLens()
      if (y <= minMaxD.minDis) {
        y = minMaxD.minDis
      }
      if (y >= minMaxD.maxDis + (this.screen_size_checked ? this.$commonViewJs.getLy() - this.$commonViewJs.getKy() : 0)) {
        y = minMaxD.maxDis + (this.screen_size_checked ? this.$commonViewJs.getLy() - this.$commonViewJs.getKy() : 0)
      }
      // 根据房间获取最大距离
      let maxDisForRoom = this.$commonViewJs.getMaxDisByRoom()
      if (y >= maxDisForRoom) {
        y = maxDisForRoom
      }
      this.screen = this.$commonViewJs.getInitScreenXyFromDist(y - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0))
      let temPjx = this.graph.pjX
      let temPjz = this.graph.pjZ
      if (!this.screen_size_checked) {
        this.PJY(y - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0))
        // this.SCREENSIZE(this.$commonViewJs.getScreenByFromDistWide(y - this.offset))
        // let screenNow = this.$commonViewJs.getScreenXyFromDist(y - this.offset)
        // this.SCRNW(screenNow.calX)
        // this.SCRNH(screenNow.calY)
        if (this.throw_distance_checked) {
          temPjz = this.houseInfo.roomH - (this.flToB + this.screen.calY / 2 - this.screen.calY * this.vLensShiftNow / 100)
          temPjx = this.flToL + this.screen.calX / 2 - this.screen.calX * this.hLensShiftNow / 100
        }
      }
      this.outRoomHeight = this.$commonViewJs.getMaxOutRoomH(this.screen.calY)
      this.outRoomWidth = this.$commonViewJs.getMaxOutRoomW(this.screen.calX)
      temPjz = this.$commonJs.checkRange(temPjz, -this.outRoomHeight + this.limitData, this.houseInfo.roomH - this.limitData)
      temPjx = this.$commonJs.checkRange(temPjx, -this.outRoomWidth + this.limitData, this.houseInfo.roomW + this.outRoomWidth - this.limitData)
      this.PJZ(temPjz)
      this.PJX(temPjx)
      if (this.screen_size_checked) {
        if (y < this.$commonViewJs.getKy()) {
          y = this.$commonViewJs.getKy()
        }
        if (y > this.$commonViewJs.getLy()) {
          y = this.$commonViewJs.getLy()
        }
        this.PJY(y - this.offset - (this.curveDirection === '1' ? this.curveDepth : 0))
        this.checkIsElectron()
      }
    },
    checkMovePjz (z) {
      let vLens
      this.outRoomHeight = this.$commonViewJs.getMaxOutRoomH(this.initScreenSize.h)
      if (z < -this.outRoomHeight + this.limitData) {
        z = -this.outRoomHeight + this.limitData
      }
      if (z > this.houseInfo.roomH - this.limitData) {
        z = this.houseInfo.roomH - this.limitData
      }
      if (this.throw_distance_checked) {
        vLens = (z - (this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2))) / this.initScreenSize.h
        this.PJZ(z)
        this.SET_VLENSSHIFT(vLens * 100)
      } else {
        this.PJZ(z)
      }
    },
    checkMovePjx (x) {
      this.outRoomWidth = this.$commonViewJs.getMaxOutRoomW(this.initScreenSize.w)
      if (x < -this.outRoomWidth + this.limitData) {
        x = -this.outRoomWidth + this.limitData
      }
      if (x > this.houseInfo.roomW + this.outRoomWidth - this.limitData) {
        x = this.houseInfo.roomW + this.outRoomWidth - this.limitData
      }
      if (this.throw_distance_checked) {
        this.PJX(x)
        this.SET_HLENSSHIFT((this.flToL + this.initScreenSize.w / 2 - x) / this.initScreenSize.w * 100.0)
      } else {
        this.PJX(x)
      }
    },
    // 键盘事件
    handleKeyDown (e) {
      // window.direction = ''
      let mv = this.getMoveDisByUnit()
      // 鼠标不在frontView中，无法触发键盘上下左右事件
      // 键盘按键判断:左箭头-37;上箭头-38；右箭头-39;下箭头-40
      if (!this.focusView) {
        return
      }

      if (e.keyCode > 36 && e.keyCode < 41) { e.preventDefault() }

      let newTime = new Date().getTime()
      if (newTime - this.moveTime < 500) {
        return
      }
      this.moveTime = new Date().getTime()
      // 左视图
      if (this.focusView === 'Side View' && this.id === 'sideView' && this.projectorCheckedSide) {
        let xMove = this.graph.pjY + this.offset + (this.curveDirection === '1' ? this.curveDepth : 0)
        let yMove = this.graph.pjZ
        if (e.keyCode === 37 && !this.realThrowDistanceChecked) {
          xMove = xMove - mv
          this.checkMovePjy(xMove)
        } else if (e.keyCode === 39 && !this.realThrowDistanceChecked) {
          xMove = xMove + mv
          this.checkMovePjy(xMove)
        } else if (e.keyCode === 38 && !this.floorFootProjectorChecked) {
          yMove = yMove - mv
          this.checkMovePjz(yMove)
        } else if (e.keyCode === 40 && !this.floorFootProjectorChecked) {
          yMove = yMove + mv
          this.checkMovePjz(yMove)
        }
      }
      // topView
      if (this.focusView === 'Top View' && this.id === 'topView' && this.projectorCheckedTop) {
        let xMove = this.graph.pjY + this.offset + (this.curveDirection === '1' ? this.curveDepth : 0)
        let yMove = this.graph.pjX
        if (e.keyCode === 37 && !this.realThrowDistanceChecked) {
          xMove = xMove - mv
          this.checkMovePjy(xMove)
        } else if (e.keyCode === 39 && !this.realThrowDistanceChecked) {
          xMove = xMove + mv
          this.checkMovePjy(xMove)
        } else if (e.keyCode === 38) {
          yMove = yMove + mv
          this.checkMovePjx(yMove)
        } else if (e.keyCode === 40) {
          yMove = yMove - mv
          this.checkMovePjx(yMove)
        }
      }

      if (this.focusView === 'Front View' && this.id === 'frontView') {
        if (this.projectorChecked) {
          let xMove = this.graph.pjX
          let zMove = this.graph.pjZ
          if (e.keyCode === 37) {
            xMove = xMove - mv
            this.checkMovePjx(xMove)
          } else if (e.keyCode === 38 && !this.floorFootProjectorChecked) {
            zMove = zMove - mv
            this.checkMovePjz(zMove)
          } else if (e.keyCode === 39) {
            xMove = xMove + mv
            this.checkMovePjx(xMove)
          } else if (e.keyCode === 40 && !this.floorFootProjectorChecked) {
            zMove = zMove + mv
            this.checkMovePjz(zMove)
          }
        } else if (this.screenMoveChecked) {
          let vAngleMove = this.vLensShiftNow
          let hAngleMove = this.hLensShiftNow
          vAngleMove = this.initScreenSize.h * vAngleMove / 100
          hAngleMove = this.initScreenSize.w * hAngleMove / 100
          if (e.keyCode === 37) {
            for (let i = 0; i < this.blackDrawData[0].length; i++) {
              if (this.blackDrawData[0][i].y > this.limitData && this.blackDrawData[0][i].x < this.limitData) {
                return
              }
            }
            hAngleMove = (hAngleMove - mv) / this.initScreenSize.w
            // window.direction = 'X'
            this.SET_HLENSSHIFT(hAngleMove * 100)
          } else if (e.keyCode === 38) {
            for (let i = 0; i < this.blackDrawData[0].length; i++) {
              if (this.blackDrawData[0][i].y > this.limitData && this.blackDrawData[0][i].z < this.limitData) {
                return
              }
            }
            vAngleMove = (vAngleMove + mv) / this.initScreenSize.h
            this.SET_VLENSSHIFT(vAngleMove * 100)
          } else if (e.keyCode === 39) {
            for (let i = 0; i < this.blackDrawData[0].length; i++) {
              if (this.blackDrawData[0][i].y > this.limitData && Math.abs(this.blackDrawData[0][i].x - this.houseInfo.roomW) < this.limitData) {
                return
              }
            }
            hAngleMove = (hAngleMove + mv) / this.initScreenSize.w
            this.SET_HLENSSHIFT(hAngleMove * 100)
          } else if (e.keyCode === 40) {
            for (let i = 0; i < this.blackDrawData[0].length; i++) {
              if (this.blackDrawData[0][i].y > this.limitData && Math.abs(this.blackDrawData[0][i].z - this.houseInfo.roomH) < this.limitData) {
                return
              }
            }
            vAngleMove = (vAngleMove - mv) / this.initScreenSize.h
            this.SET_VLENSSHIFT(vAngleMove * 100)
          }
        }
      }
    },

    handelKeyUp () {
      this.moveTime = 0
    },
    /**
     * 鼠标拖动时，按照当前最小单位刻度来进行拖动，
     * m、mm 拖动1cm
     * inch 拖动0.254cm
     * feet 拖动3.048cm
     */
    getMoveDisByUnit () {
      let unit = this.graph.unit
      let moveDis = 0
      if (unit === 'T_METRE_M' || unit === 'T_MILLIMETER_MM') {
        moveDis = 1
      } else if (unit === 'T_INCH_DECIMAL') {
        moveDis = 0.254
      } else if (unit === 'T_FEET_DECIMAL') {
        moveDis = 3.048
      }
      return moveDis
    },
    initCanvasWH () {
      if (!this.$refs.canvas_side) {
        return
      }
      let offsetW = this.$refs.canvas_side.offsetWidth
      let offsetH = this.$refs.canvas_side.offsetHeight
      this.canvas.width = offsetW
      this.canvas.height = offsetH
    },
    getProportion () {
      if (!this.$refs.canvas) {
        return
      }
      let calw = this.w
      let calh = this.h
      const wRatio = calw / this.$refs.canvas.width
      const hRatio = calh / this.$refs.canvas.height
      let maxSize = parseFloat(this.$refs.canvas.height)
      let xFactor = this.id === 'frontView' ? 0.6 : 0.7
      if (wRatio >= hRatio) {
        maxSize = parseFloat(this.$refs.canvas.width)
      }
      maxSize = Number(maxSize) * xFactor
      if (wRatio >= hRatio) {
        this.proportion = calw * 1 / maxSize
      } else {
        this.proportion = calh * 1 / maxSize
      }
    },
    initCanvasXY () {
      this.cvX = (this.canvas.width - this.realToCanvas(this.w)) / 2
      this.cvY = (this.canvas.height - this.realToCanvas(this.h)) / 2
      this.context.translate(this.cvX, this.cvY)
    },
    clearCanvas () {
      this.context.clearRect(
        -this.cvX,
        -this.cvY,
        this.canvas.width,
        this.canvas.height
      )
    },
    refreshCv () {
      this.initCanvasWH()
      this.getProportion()
      this.initCanvasXY()
    },
    drawCv () {
      this.clearCanvas()
      this.$emit('setArrHelpLine', this.proportion)
      this.drawRoomRect()
      this.drawCurveRects()
      this.drawRects()
      this.drawAvlRect()
      this.drawBlackArea()
      if (this.isOutOfSpec && (this.id === 'sideView' || this.id === 'topView')) {
      } else {
        this.drawLightingArea()
        this.drawCatchArea()
      }

      this.drawRectLines()
      this.drawPj()
      this.drawDashLines()
      this.drawDashRemainLines()
      this.drawOffsetLines()
      this.drawHelpLines()
      this.drawQuickCornerAreas()
      this.drawQuickCornerLines()
      this.drawHelpText()
      this.drawRectHorSecLinesOnCanvas()
      this.drawArrowRects()
    },
    /**
     * 鼠标点击
     */
    onCanvasMouseDown (e) {
      // this.oldPosition.x = e.offsetX
      // this.oldPosition.y = e.offsetY
      if (this.id === 'sideView') {
        if (!this.projectorCheckedSide) {
          return
        }
      } else if (this.id === 'topView') {
        if (!this.projectorCheckedTop) {
          return
        }
      }
      let offsetX = e.offsetX || (e.clientX - e.target.getBoundingClientRect().left)
      let offsetY = e.offsetY || (e.clientY - e.target.getBoundingClientRect().top)
      var clickX = offsetX - this.cvX
      var clickY = offsetY - this.cvY
      //  查找被单击的矩形框
      var rect = this.pjRectOnCanvas

      this.isMouseInCanvas = true

      if (this.id === 'frontView' && this.screenMoveChecked) {
        // 当选中拖动的是屏幕时，拖动frontView
        let maxX = this.drawData[1][0].x
        let minX = this.drawData[1][0].x
        let maxZ = this.drawData[1][0].z
        let minZ = this.drawData[1][0].z
        for (let i = 1; i < this.drawData.length; i++) {
          for (let j = 0; j < this.drawData[i].length; j++) {
            if (this.drawData[i][j].x > maxX) {
              maxX = this.drawData[i][j].x
            }
            if (this.drawData[i][j].x < minX) {
              minX = this.drawData[i][j].x
            }
            if (this.drawData[i][j].z > maxZ) {
              maxZ = this.drawData[i][j].z
            }
            if (this.drawData[i][j].z < minZ) {
              minZ = this.drawData[i][j].z
            }
          }
        }
        if (clickX >= this.realToCanvas(minX) && clickX < this.realToCanvas(maxX) && clickY >= this.realToCanvas(minZ) && clickY < this.realToCanvas(maxZ)) {
          this.x1 = clickX - this.realToCanvas(minX)
          this.y1 = clickY - this.realToCanvas(minZ)
          rect.x = this.realToCanvas(minX)
          rect.y = this.realToCanvas(minZ)
          rect.width = this.realToCanvas(maxX - minX)
          rect.height = this.realToCanvas(maxZ - minZ)
          this.selectedRect = rect
          //  使圆圈允许拖拽
          this.isDragging = true
        }
      } else {
        this.widthstart = rect.x
        this.widthend = rect.x + rect.width

        this.heightstart = rect.y
        this.heightend = rect.y + rect.height

        //  判断这个点是否在矩形框中
        if (clickX >= this.widthstart && clickX < this.widthend && clickY >= this.heightstart && clickY < this.heightend) {
          //  清除之前选择的矩形框
          this.selectedRect = rect
          this.x1 = clickX - this.selectedRect.x
          this.y1 = clickY - this.selectedRect.y
          //  使圆圈允许拖拽
          this.isDragging = true
        }
      }

      // if (
      //   clickX >= this.widthend - 20 &&
      //   clickX <= this.widthend + 20 &&
      //   clickY >= this.heightend - 20 &&
      //   clickY >= this.heightend + 20
      // ) {
      //   this.selectedRect = rect
      // }
    },
    /**
     * 拖拽投影仪
     */
    onCanvasMouseMove (e) {
      let cvXreal
      let cvYreal
      // if (e.offsetY === this.oldPosition.y && e.offsetX !== this.position.x) {
      //   // window.direction = 'X'
      // } else {
      //   window.direction = ''
      // }

      if (this.isMouseInCanvas === false) {
        return
      }
      // 判断矩形是否开始拖拽
      if (this.isDragging === true) {
        // 判断拖拽对象是否存在
        if (this.selectedRect != null) {
          // 取得鼠标位置
          var x = e.offsetX || (e.clientX - e.target.getBoundingClientRect().left)
          var y = e.offsetY || (e.clientY - e.target.getBoundingClientRect().top)
          if (this.id === 'frontView') {
            if (this.projectorChecked) {
              this.outRoomHeight = this.$commonViewJs.getMaxOutRoomH(this.initScreenSize.h)
              this.outRoomWidth = this.$commonViewJs.getMaxOutRoomW(this.initScreenSize.w)
              // 将圆圈移动到鼠标位置
              if (x - this.x1 - this.cvX <= this.roomRectOnCanvas.x - this.pjRectOnCanvas.width / 2 - this.realToCanvas(this.outRoomWidth) + this.realToCanvas(this.limitData)) {
                x = this.roomRectOnCanvas.x + this.x1 + this.cvX - this.pjRectOnCanvas.width / 2 - this.realToCanvas(this.outRoomWidth) + this.realToCanvas(this.limitData)
              }
              if (y - this.y1 - this.cvY <= this.roomRectOnCanvas.y - this.pjRectOnCanvas.height / 2 - this.realToCanvas(this.outRoomHeight) + this.realToCanvas(this.limitData)) {
                y = this.roomRectOnCanvas.y + this.y1 + this.cvY - this.pjRectOnCanvas.height / 2 - this.realToCanvas(this.outRoomHeight) + this.realToCanvas(this.limitData)
              }
              if (x - this.x1 - this.cvX >= this.roomRectOnCanvas.x + this.roomRectOnCanvas.width - this.pjRectOnCanvas.width / 2 + this.realToCanvas(this.outRoomWidth) - this.realToCanvas(this.limitData)) {
                x = this.roomRectOnCanvas.x + this.roomRectOnCanvas.width + this.x1 + this.cvX - this.pjRectOnCanvas.width / 2 + this.realToCanvas(this.outRoomWidth) - this.realToCanvas(this.limitData)
              }
              if (y - this.y1 - this.cvY >= this.roomRectOnCanvas.y + this.roomRectOnCanvas.height - this.pjRectOnCanvas.height / 2 - this.realToCanvas(this.limitData)) {
                y = this.roomRectOnCanvas.y + this.roomRectOnCanvas.height + this.y1 + this.cvY - this.pjRectOnCanvas.height / 2 - this.realToCanvas(this.limitData)
              }
              if (!this.screen_size_checked && this.throw_distance_checked) {
                cvXreal = this.canvasToReal(x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2)
                cvYreal = this.canvasToReal(y - this.y1 - this.cvY + this.pjRectOnCanvas.height / 2)
                this.SET_HLENSSHIFT((this.flToL + this.initScreenSize.w / 2 - cvXreal) / this.initScreenSize.w * 100.0)
                this.SET_VLENSSHIFT((this.flToB + this.initScreenSize.h / 2 - (this.houseInfo.roomH - cvYreal)) / this.initScreenSize.h * 100.0)
              } else {
                // 选中两个按钮时

                cvXreal = this.canvasToReal(x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2)
                cvYreal = this.canvasToReal(y - this.y1 - this.cvY + this.pjRectOnCanvas.height / 2)
                if (this.throw_distance_checked && this.screen_size_checked) {
                  if (cvYreal < this.$commonViewJs.getKz()) {
                    cvYreal = this.$commonViewJs.getKz()
                  }
                  if (cvYreal > this.$commonViewJs.getLz()) {
                    cvYreal = this.$commonViewJs.getLz()
                  }
                  if (cvXreal > this.$commonViewJs.getPx()) {
                    cvXreal = this.$commonViewJs.getPx()
                  }
                  if (cvXreal < this.$commonViewJs.getQx()) {
                    cvXreal = this.$commonViewJs.getQx()
                  }
                  var hLens2 = Number(((this.flToL + this.initScreenSize.w / 2) - cvXreal) / this.initScreenSize.w * 100)
                  var vLens2 = Number((cvYreal - (this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2))) / this.initScreenSize.h * 100)
                  this.SET_HLENSSHIFT((hLens2))
                  this.SET_VLENSSHIFT((vLens2))
                }
                if (this.floor_footProjector_checked) {
                  cvYreal = this.graph.pjZ
                }
                this.PJX(cvXreal)
                this.PJZ(cvYreal)
              }
            } else if (this.screenMoveChecked) {
              // 拖动屏幕
              var hLens = -Number((this.graph.pjX - this.canvasToReal(x - this.x1 - this.cvX + this.selectedRect.width / 2)) / this.initScreenSize.w * 100.0)
              var vLens = Number((this.graph.pjZ - this.canvasToReal(y - this.y1 - this.cvY + this.selectedRect.height / 2)) / this.initScreenSize.h * 100.0)
              this.SET_HLENSSHIFT(hLens)
              this.SET_VLENSSHIFT(vLens)
            }
          } else {
            var minMaxD = this.$commonViewJs.getMinDisByLens()
            var minD = this.isOutOfSpec ? this.realToCanvas(this.offset + (this.curveDirection === '1' ? this.curveDepth : 0) + this.limitData) : this.realToCanvas(minMaxD.minDis)
            var maxD = this.isOutOfSpec ? Number.POSITIVE_INFINITY : this.realToCanvas(minMaxD.maxDis)

            if (!this.isOutOfSpec && !this.realThrowDistanceChecked) {
              if (!this.screen_size_checked) {
                if (x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 >= maxD) {
                  x = maxD + this.x1 + this.cvX - this.pjRectOnCanvas.width / 2
                }
              }
              if (x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 > this.roomRectOnCanvas.x + this.roomRectOnCanvas.width) {
                x = this.roomRectOnCanvas.x + this.roomRectOnCanvas.width + this.x1 + this.cvX - this.pjRectOnCanvas.width / 2
              }
              if (x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 >= this.realToCanvas(this.$commonViewJs.getMaxDisByRoom())) {
                x = this.realToCanvas(this.$commonViewJs.getMaxDisByRoom()) + this.x1 + this.cvX - this.pjRectOnCanvas.width / 2
              }
            }

            if (x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 <= minD && !this.realThrowDistanceChecked) {
              x = minD + this.x1 + this.cvX - this.pjRectOnCanvas.width / 2
            }
            cvXreal = this.canvasToReal(x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 - this.realToCanvas(this.offset) - (this.curveDirection === '1' ? this.realToCanvas(this.curveDepth) : 0))
            this.screen = this.$commonViewJs.getInitScreenXyFromDist(cvXreal)
            let screenH = (this.screen_size_checked || this.realThrowDistanceChecked) ? this.initScreenSize.h : this.screen.calY
            let screenW = (this.screen_size_checked || this.realThrowDistanceChecked) ? this.initScreenSize.w : this.screen.calX
            this.outRoomHeight = this.$commonViewJs.getMaxOutRoomH(screenH)
            this.outRoomWidth = this.$commonViewJs.getMaxOutRoomW(screenW)
            let moveHeight = this.id === 'topView' ? this.outRoomWidth : this.outRoomHeight
            if (y - this.y1 - this.cvY < this.roomRectOnCanvas.y - this.pjRectOnCanvas.height / 2 - this.realToCanvas(moveHeight) + this.realToCanvas(this.limitData)) {
              y = this.roomRectOnCanvas.y + this.y1 + this.cvY - this.pjRectOnCanvas.height / 2 - this.realToCanvas(moveHeight) + this.realToCanvas(this.limitData)
            }
            let moveTopHeight = this.id === 'topView' ? this.outRoomWidth : 0
            if (y - this.y1 - this.cvY > this.roomRectOnCanvas.y + this.roomRectOnCanvas.height - this.pjRectOnCanvas.height / 2 + this.realToCanvas(moveTopHeight) - this.realToCanvas(this.limitData)) {
              y = this.roomRectOnCanvas.y + this.roomRectOnCanvas.height - this.pjRectOnCanvas.height / 2 + this.realToCanvas(moveTopHeight) + this.y1 + this.cvY - this.realToCanvas(this.limitData)
            }
            if (this.isOutOfSpec) {
              // let screen = this.$commonViewJs.getScreenXyFromDist(cvXreal)
              if ((cvXreal + this.offset + (this.curveDirection === '1' ? this.curveDepth : 0)) > this.houseInfo.roomD) {
                this.SET_GRAPH_ROOMD(cvXreal + this.offset + (this.curveDirection === '1' ? this.curveDepth : 0))
              }
              // if (this.realToCanvas(this.$commonViewJs.getMaxDisByRoom()) < x) {
              //   if (this.houseInfo.roomW <= screen.calX) {
              //     this.SET_GRAPH_ROOMW(screen.calX)
              //   }
              //   if (this.houseInfo.roomH <= screen.calY) {
              //     this.SET_GRAPH_ROOMH(screen.calY)
              //   }
              // }
            }
            if (!this.realThrowDistanceChecked) {
              if (this.screen_size_checked) {
                if (x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 < this.realToCanvas(this.$commonViewJs.getKy())) {
                  x = this.realToCanvas(this.$commonViewJs.getKy()) + this.x1 + this.cvX - this.pjRectOnCanvas.width / 2
                }
                if (x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 > this.realToCanvas(this.$commonViewJs.getLy())) {
                  x = this.realToCanvas(this.$commonViewJs.getLy()) + this.x1 + this.cvX - this.pjRectOnCanvas.width / 2
                }
                cvXreal = this.canvasToReal(x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 - this.realToCanvas(this.offset) - (this.curveDirection === '1' ? this.realToCanvas(this.curveDepth) : 0))
                this.PJY(cvXreal)
                // 计算当当前投影仪不为超短焦，并且为电子变焦时
                this.checkIsElectron()
              } else {
                this.SCREENSIZE(this.$commonViewJs.getScreenByFromDistWide(cvXreal))
                this.PJY(cvXreal)
                let screenNow = this.$commonViewJs.getScreenXyFromDist(cvXreal)
                this.SCRNW(screenNow.calX)
                this.SCRNH(screenNow.calY)
              }
            }
            // cvXreal = this.canvasToReal(x - this.x1 - this.cvX + this.pjRectOnCanvas.width / 2 - this.realToCanvas(this.offset))
            // this.checkMovePjy(cvXreal)
            cvYreal = this.canvasToReal(y - this.y1 - this.cvY + this.pjRectOnCanvas.height / 2)
            if (this.id === 'sideView') {
              let temPjx = this.graph.pjX
              if (this.throw_distance_checked && this.screen_size_checked) {
                vLens = (cvYreal - (this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2))) / this.initScreenSize.h
                // 选中两个按钮时
                if (vLens < this.graph.vLensShift.min) {
                  vLens = this.graph.vLensShift.min
                  cvYreal = this.graph.vLensShift.min * this.initScreenSize.h + (this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2))
                }
                if (vLens > this.graph.vLensShift.max) {
                  vLens = this.graph.vLensShift.max
                  cvYreal = this.graph.vLensShift.max * this.initScreenSize.h + (this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2))
                }
                this.SET_VLENSSHIFT(vLens * 100)
              } else if (this.throw_distance_checked && !this.screen_size_checked && !this.realThrowDistanceChecked) {
                // 仅选中Screen Position的checkbox时
                vLens = (cvYreal - (this.houseInfo.roomH - (this.flToB + this.screen.calY / 2))) / this.screen.calY
                temPjx = this.flToL + this.screen.calX / 2 - this.screen.calX * this.hLensShiftNow / 100
                if (vLens < this.graph.vLensShift.min) {
                  vLens = this.graph.vLensShift.min
                  cvYreal = this.graph.vLensShift.min * this.screen.calY + (this.houseInfo.roomH - (this.flToB + this.screen.calY / 2))
                }
                if (vLens > this.graph.vLensShift.max) {
                  vLens = this.graph.vLensShift.max
                  cvYreal = this.graph.vLensShift.max * this.screen.calY + (this.houseInfo.roomH - (this.flToB + this.screen.calY / 2))
                }
                this.SET_VLENSSHIFT(vLens * 100)
              } else if (this.throw_distance_checked && this.realThrowDistanceChecked) {
                // 仅选中Screen Position的checkbox时
                vLens = (cvYreal - (this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2))) / this.initScreenSize.h
                if (vLens < this.graph.vLensShift.min) {
                  vLens = this.graph.vLensShift.min
                  cvYreal = this.graph.vLensShift.min * this.initScreenSize.h + (this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2))
                }
                if (vLens > this.graph.vLensShift.max) {
                  vLens = this.graph.vLensShift.max
                  cvYreal = this.graph.vLensShift.max * this.initScreenSize.h + (this.houseInfo.roomH - (this.flToB + this.initScreenSize.h / 2))
                }
                this.SET_VLENSSHIFT(vLens * 100)
              }
              this.outRoomHeight = this.$commonViewJs.getMaxOutRoomH(screenH)
              let temPjz = cvYreal
              if (!((this.$commonViewJs.isLongLensExistsLens() && this.$commonViewJs.isLongLensExistsTLens()) || this.selectedModelData.category === 4)) temPjz = this.$commonJs.checkRange(temPjz, -this.outRoomHeight + this.limitData, this.houseInfo.roomH - this.limitData)
              temPjx = this.$commonJs.checkRange(temPjx, -this.outRoomWidth + this.limitData, this.houseInfo.roomW + this.outRoomWidth - this.limitData)
              if (this.floor_footProjector_checked) {
                temPjz = this.graph.pjZ
              }
              this.PJZ(temPjz)
              this.PJX(temPjx)
              // this.checkMovePjz(cvYreal)
            } else if (this.id === 'topView') {
              let temPjz = this.graph.pjZ
              if (this.throw_distance_checked && this.screen_size_checked) {
                hLens = ((this.flToL + this.initScreenSize.w / 2) - (this.houseInfo.roomW - cvYreal)) / this.initScreenSize.w
                if (hLens < this.graph.hLensShift.min) {
                  hLens = this.graph.hLensShift.min
                  cvYreal = this.houseInfo.roomW - ((this.flToL + this.initScreenSize.w / 2) - this.graph.hLensShift.min * this.initScreenSize.w)
                }
                if (hLens > this.graph.hLensShift.max) {
                  hLens = this.graph.hLensShift.max
                  cvYreal = this.houseInfo.roomW - ((this.flToL + this.initScreenSize.w / 2) - this.graph.hLensShift.max * this.initScreenSize.w)
                }
                this.SET_HLENSSHIFT(hLens * 100)
              } else if (!this.screen_size_checked && this.throw_distance_checked && !this.realThrowDistanceChecked) {
                temPjz = this.houseInfo.roomH - (this.flToB + this.screen.calY / 2 - this.screen.calY * this.vLensShiftNow / 100)
                hLens = ((this.flToL + this.screen.calX / 2) - (this.houseInfo.roomW - cvYreal)) / this.screen.calX
                if (hLens < this.graph.hLensShift.min) {
                  hLens = this.graph.hLensShift.min
                  cvYreal = this.houseInfo.roomW - ((this.flToL + this.initScreenSize.w / 2) - this.graph.hLensShift.min * this.initScreenSize.w)
                }
                if (hLens > this.graph.hLensShift.max) {
                  hLens = this.graph.hLensShift.max
                  cvYreal = this.houseInfo.roomW - ((this.flToL + this.initScreenSize.w / 2) - this.graph.hLensShift.max * this.initScreenSize.w)
                }
                this.SET_HLENSSHIFT(hLens * 100)
              } else if (this.throw_distance_checked && this.realThrowDistanceChecked) {
                hLens = ((this.flToL + this.initScreenSize.w / 2) - (this.houseInfo.roomW - cvYreal)) / this.initScreenSize.w
                if (hLens < this.graph.hLensShift.min) {
                  hLens = this.graph.hLensShift.min
                  cvYreal = this.houseInfo.roomW - ((this.flToL + this.initScreenSize.w / 2) - this.graph.hLensShift.min * this.initScreenSize.w)
                }
                if (hLens > this.graph.hLensShift.max) {
                  hLens = this.graph.hLensShift.max
                  cvYreal = this.houseInfo.roomW - ((this.flToL + this.initScreenSize.w / 2) - this.graph.hLensShift.max * this.initScreenSize.w)
                }
                this.SET_HLENSSHIFT(hLens)
              }
              this.outRoomWidth = this.$commonViewJs.getMaxOutRoomW(screenW)
              let temPjx = this.houseInfo.roomW - cvYreal
              temPjz = this.$commonJs.checkRange(temPjz, -this.outRoomHeight + this.limitData, this.houseInfo.roomH - this.limitData)
              temPjx = this.$commonJs.checkRange(temPjx, -this.outRoomWidth + this.limitData, this.houseInfo.roomW + this.outRoomWidth - this.limitData)
              this.PJZ(temPjz)
              this.PJX(temPjx)
            }
          }
        }
      }
      // this.oldPosition.x = e.offsetX
      // this.oldPosition.y = e.offsetY
    },

    checkIsElectron () {
      let flag = 1
      if (this.position !== 0) {
        flag = -1
      }
      let vlensShiftN
      let defaultDistInfo = this.$commonJs.findSpecInfoByRatio(this.aspectRatio, this.selectedLensData)
      // 计算当当前投影仪不为超短焦，并且为电子变焦时
      if (this.screen_size_checked && this.$commonViewJs.isLongLensExistsLens() && this.$commonViewJs.isLongLensExistsTLens()) {
        let wSize = this.$commonViewJs.getScreenSizeFromDist(this.graph.pjY)
        let wSizeInch = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
        let l = (wSize.calY - this.graph.scrnH) / 2
        let v2 = defaultDistInfo.wv.wv2 * wSizeInch
        let v2l = v2 - l
        vlensShiftN = (v2l - this.graph.scrnH / 2) / this.initScreenSize.h * flag
      } else if (this.screen_size_checked && this.selectedModelData.category === 4) {
        let wSize = this.$commonViewJs.getScreenSizeFromDist(this.graph.pjY)
        let wSizeInch = this.$commonViewJs.getScreenByFromDistWide(this.graph.pjY)
        let v1b = wSizeInch * defaultDistInfo.v1b.w.a + defaultDistInfo.v1b.w.b
        let l = (wSize.calY - this.graph.scrnH) / 2
        vlensShiftN = (wSize.calY / 2 + v1b - this.selectedLensData.mu - l) / this.initScreenSize.h * flag
      }
      if (vlensShiftN) {
        this.SET_VLENSSHIFT(vlensShiftN * 100)
        let vals = {}
        vals.max = vlensShiftN
        vals.min = vlensShiftN
        this.VLENSSHIFT(vals)
        let ll = {}
        ll.max = vlensShiftN * flag
        ll.min = vlensShiftN * flag
        this.SET_TEMVLENSSHIFT(ll)
      }
    },

    onCanvasMouseOut (e) {
      this.isMouseInCanvas = false
    },
    /**
     * 鼠标松开
     */
    onCanvasMouseUp () {
      this.isDragging = false
      this.isMouseInCanvas = false
    },
    onHouseInfoChanged () {
      this.context.translate(-this.cvX, -this.cvY)
      this.getProportion()
      this.initCanvasXY()
      this.drawCv()
    },
    onGraphChanged () {
      this.drawCv()
    },
    initPjImg () {
      this.pjImg.onload = function () {
        this.drawCv()
      }.bind(this)
      this.pjImg.src = this.$commonJs.getPjImgUrl(this.id, this.pjImgType, this.selectedLensData)
    },
    drawPjImg () {
      this.context.drawImage(
        this.pjImg,
        this.pjRectOnCanvas.x,
        this.pjRectOnCanvas.y,
        this.pjRectOnCanvas.width,
        this.pjRectOnCanvas.height
      )
    },
    drawPjImgRotate (x, y, angle) {
      this.context.save()
      this.context.translate(x, y)
      this.context.rotate(angle * Math.PI / 180)
      this.context.translate(-x, -y)
      this.drawPjImg()
      this.context.restore()
    },
    drawPj () {
      let x, y
      if (this.id === 'sideView') {
        if (this.$commonViewJs.isVAngle()) {
          x = this.realToCanvas(this.graph.pjY + this.offset + (this.curveDirection === '1' ? this.curveDepth : 0))
          y = this.realToCanvas(this.graph.pjZ)

          this.drawPjImgRotate(x, y, this.vAngle)
          return
        }
      } else if (this.id === 'topView') {
        if (this.$commonViewJs.isHAngle()) {
          x = this.realToCanvas(this.graph.pjY + this.offset + (this.curveDirection === '1' ? this.curveDepth : 0))
          y = this.realToCanvas(this.houseInfo.roomW - this.graph.pjX)

          this.drawPjImgRotate(x, y, this.hAngle)
          return
        }
      }
      this.drawPjImg()
    },
    drawRoomRect () {
      this.$draw.drawRect(
        this.context,
        this.roomRectOnCanvas.x,
        this.roomRectOnCanvas.y,
        this.roomRectOnCanvas.width,
        this.roomRectOnCanvas.height,
        this.$constant.roomLineColor,
        this.$constant.roomFillColor,
        1,
        true
      )
    },
    drawAvlRect () {
      if (this.$commonViewJs.isAvlExist() || this.avlRect) {
        if (this.id === 'frontView') {
          this.$draw.drawPath(
            this.context,
            this.avlRectOnCanvas,
            this.$constant.avlRangeColor
          )
        } else {
          this.$draw.drawRect(
            this.context,
            this.avlRectOnCanvas.x,
            this.avlRectOnCanvas.y,
            this.avlRectOnCanvas.width,
            this.avlRectOnCanvas.height,
            this.$constant.avlRangeColor,
            this.$constant.avlRangeColor,
            1,
            true
          )
        }
      }
    },
    drawDashLines () {
      for (var i = 0; i < this.arrDashLinesOnCanvas.length; i++) {
        this.$draw.drawLine(
          this.context,
          this.arrDashLinesOnCanvas[i],
          this.$constant.dashLineColor,
          this.arrDashLinesOnCanvas[i].lineWidth,
          [2, 2]
        )
      }
    },
    drawDashRemainLines () {
      for (var i = 0; i < this.arrDashRemainLinesOnCanvas.length; i++) {
        this.$draw.drawLine(
          this.context,
          this.arrDashRemainLinesOnCanvas[i],
          this.$constant.dashRemainLineColor,
          this.arrDashRemainLinesOnCanvas[i].lineWidth,
          [2, 2]
        )
      }
    },
    drawOffsetLines () {
      if (this.id !== 'frontView') {
        for (var i = 0; i < this.arrOffsetLinesOnCanvas.length; i++) {
          this.$draw.drawLine(
            this.context,
            this.arrOffsetLinesOnCanvas[i],
            this.$constant.dashLineColor,
            this.arrOffsetLinesOnCanvas[i].lineWidth,
            [2, 2]
          )
        }
      }
    },
    drawRectLines () {
      var i, color, lineWidth
      for (i = 0; i < this.arrRectLinesOnCanvas.length; i++) {
        color = this.arrRectLinesOnCanvas[i].color
        lineWidth = this.arrRectLinesOnCanvas[i].lineWidth
        this.$draw.drawLine(
          this.context,
          this.arrRectLinesOnCanvas[i],
          color,
          lineWidth
        )
      }
      if (this.id !== 'frontView') {
        let reColor = this.$constant.rectLineColor
        if (this.id === 'sideView') {
          for (let i = 1; i < this.drawData.length; i++) {
            for (let j = 0; j < this.drawData[i].length; j++) {
              if (this.drawData[i][j].x < this.limitData || Math.abs(this.drawData[i][j].x - this.houseInfo.roomW) < this.limitData) {
                reColor = this.$constant.rectFillColor
              }
            }
          }
        }
        if (this.id === 'topView') {
          for (let i = 1; i < this.drawData.length; i++) {
            for (let j = 0; j < this.drawData[i].length; j++) {
              if (this.drawData[i][j].z < this.limitData || Math.abs(this.drawData[i][j].z - this.houseInfo.roomH) < this.limitData) {
                reColor = this.$constant.rectFillColor
              }
            }
          }
        }
        lineWidth = 3
        this.$draw.drawLines(
          this.context,
          this.arrCatchAreaOnCanvas,
          reColor,
          lineWidth
        )
      } else {
      // 设置边框色，因为frontView无边框色，
        this.$draw.drawLines(
          this.context,
          this.arrCatchAreaOnCanvas,
          this.$constant.catchAreaColor,
          lineWidth
        )
      }
    },
    /**
     * 为frontView，topView添加投影区域填充色
     */
    drawLightingArea () {
      if (this.id !== 'frontView') {
        for (let i = 0; i < this.arrLightingAreaOnCanvas.length; i++) {
          this.$draw.drawPath(
            this.context,
            this.arrLightingAreaOnCanvas[i],
            this.$constant.catchAreaColor
          )
        }
      }
    },
    drawCatchArea () {
      if (this.id === 'frontView') {
        this.$draw.drawPath(
          this.context,
          this.arrCatchAreaOnCanvas,
          this.$constant.catchAreaColor
        )
      } else {
        this.$draw.drawPath(
          this.context,
          this.arrCatchAreaOnCanvas,
          this.$constant.catchFillColor
        )
      }
    },
    drawBlackArea () {
      if (this.arrBlackArea) {
        this.$draw.drawPath(
          this.context,
          this.arrBlackAreaOnCanvas,
          this.$constant.blackAreaColor
        )
      }
    },
    drawHelpLines () {
      for (var i = 0; i < this.arrHelpLinesOnCanvas.length; i++) {
        this.$draw.drawLine(
          this.context,
          this.arrHelpLinesOnCanvas[i],
          this.$constant.helpLineColor,
          0.8
        )
      }
    },
    drawQuickCornerLines () {
      if (this.arrQuickCornerLinesOnCanvas) {
        for (var i = 0; i < this.arrQuickCornerLinesOnCanvas.length; i++) {
          this.$draw.drawLine(
            this.context,
            this.arrQuickCornerLinesOnCanvas[i],
            this.arrQuickCornerLinesOnCanvas[i].color,
            this.arrQuickCornerLinesOnCanvas[i].lineWidth
          )
        }
      }
    },
    drawQuickCornerAreas () {
      if (this.arrCornerCorAreasOnCanvas) {
        for (var i = 0; i < this.arrCornerCorAreasOnCanvas.length; i++) {
          this.$draw.drawPath(
            this.context,
            this.arrCornerCorAreasOnCanvas[i],
            this.$constant.cornerAreaColor
          )
        }
      }
    },
    drawHelpText () {
      for (var i = 0; i < this.arrHelpTextOnCanvas.length; i++) {
        this.$draw.drawText(
          this.context,
          this.arrHelpTextOnCanvas[i].text,
          this.arrHelpTextOnCanvas[i].x,
          this.arrHelpTextOnCanvas[i].y,
          this.$constant.helpTextColor
        )
      }
    },
    drawArrowRects () {
      if (this.id === 'frontView') {
        for (var i = 0; i < this.arrowRectsOnCanvas.length; i++) {
          var ps = []
          var p1 = {}
          var p2 = {}
          var p3 = {}
          p1.x = this.arrowRectsOnCanvas[i].x1
          p1.y = this.arrowRectsOnCanvas[i].y1
          ps.push(p1)
          p2.x = this.arrowRectsOnCanvas[i].x2
          p2.y = this.arrowRectsOnCanvas[i].y2
          ps.push(p2)
          p3.x = this.arrowRectsOnCanvas[i].x3
          p3.y = this.arrowRectsOnCanvas[i].y3
          ps.push(p3)
          this.$draw.drawPath(
            this.context,
            ps,
            this.$constant.avlRangeColor
          )
        }
        let downDest = 0
        for (let i = 0; i < this.arrHelpLinesOnCanvas.length; i++) {
          if (this.arrHelpLinesOnCanvas[i].y1 > downDest) {
            downDest = this.arrHelpLinesOnCanvas[i].y1
          }
        }
        var leftmove = ((this.houseInfo.roomW + this.graph.pjX) / 2 + this.graph.pjX / 2) / 2
        let centerPosition = {
          x: this.realToCanvas(leftmove) + this.cvX,
          y: downDest + this.cvY + 5
        }
        this.$emit('removeCenter', centerPosition)
      } else if (this.id === 'sideView') {
        let downDest = 0
        for (let i = 0; i < this.arrHelpLinesOnCanvas.length; i++) {
          if (this.arrHelpLinesOnCanvas[i].y1 > downDest) {
            downDest = this.arrHelpLinesOnCanvas[i].y1
          }
        }
        let centerPosition = {
          x: this.cvX + 10,
          y: downDest + this.cvY
        }
        this.$emit('moveCenter', centerPosition)
      }
    },
    drawCurveRects () {
      if (this.searchTabActive === 'CurvedSurface' && this.arrCurveRectOnCanvas) {
        for (var i = 0; i < this.arrCurveRectOnCanvas.length; i++) {
          this.$draw.drawCurveAreas(
            this.context,
            this.arrCurveRectOnCanvas[i].x,
            this.arrCurveRectOnCanvas[i].y,
            this.arrCurveRectOnCanvas[i].radius,
            this.arrCurveRectOnCanvas[i].startAngle,
            this.arrCurveRectOnCanvas[i].fillAngle,
            this.arrCurveRectOnCanvas[i].lineColor,
            this.arrCurveRectOnCanvas[i].fillColor,
            this.arrCurveRectOnCanvas[i].lineWidth
          )
        }
      }
    },
    drawRects () {
      if (this.arrRectAreaOnCanvas) {
        for (var i = 0; i < this.arrRectAreaOnCanvas.length; i++) {
          this.$draw.drawRect(
            this.context,
            this.arrRectAreaOnCanvas[i].x,
            this.arrRectAreaOnCanvas[i].y,
            this.arrRectAreaOnCanvas[i].width,
            this.arrRectAreaOnCanvas[i].height,
            this.$constant.roomLineColor,
            this.$constant.roomFillColor,
            1,
            true
          )
        }
      }
    },
    drawRectHorSecLinesOnCanvas () {
      if (this.arrRectHorSecLinesOnCanvas === null || this.arrRectHorSecLinesOnCanvas === undefined) {
        return
      }

      var i, color, lineWidth
      for (i = 0; i < this.arrRectHorSecLinesOnCanvas.length; i++) {
        color = this.arrRectHorSecLinesOnCanvas[i].color
        lineWidth = this.arrRectHorSecLinesOnCanvas[i].lineWidth
        this.$draw.drawLine(
          this.context,
          this.arrRectHorSecLinesOnCanvas[i],
          color,
          lineWidth
        )
      }
    },
    r2c (r) {
      let x = r.x ? this.realToCanvas(r.x) : 0
      let y = r.y ? this.realToCanvas(r.y) : 0
      let w = r.width ? this.realToCanvas(r.width) : 0
      let h = r.height ? this.realToCanvas(r.height) : 0

      return this.$draw.toRect(x, y, w, h)
    },
    l2c (l) {
      if (l === null || l === undefined) {
        return
      }
      let tmp = []
      let x1, y1, x2, y2
      for (let i = 0; i < l.length; i++) {
        x1 = l[i].x1 ? this.realToCanvas(l[i].x1) : 0
        y1 = l[i].y1 ? this.realToCanvas(l[i].y1) : 0
        x2 = l[i].x2 ? this.realToCanvas(l[i].x2) : 0
        y2 = l[i].y2 ? this.realToCanvas(l[i].y2) : 0
        tmp.push(this.$draw.toLine(x1, y1, x2, y2, l[i].color, l[i].lineWidth))
      }
      return tmp
    },
    arp2c (l) {
      if (l === null || l === undefined) {
        return
      }
      let tmp = []
      let x1, y1, x2, y2, x3, y3
      for (let i = 0; i < l.length; i++) {
        x1 = l[i].x1 ? this.realToCanvas(l[i].x1) : 0
        y1 = l[i].y1 ? this.realToCanvas(l[i].y1) : 0
        x2 = l[i].x2 ? this.realToCanvas(l[i].x2) : 0
        y2 = l[i].y2 ? this.realToCanvas(l[i].y2) : 0
        x3 = l[i].x3 ? this.realToCanvas(l[i].x3) : 0
        y3 = l[i].y3 ? this.realToCanvas(l[i].y3) : 0
        tmp.push(this.$draw.toArrow(x1, y1, x2, y2, x3, y3, l[i].color))
      }
      return tmp
    },
    canp2c (l) {
      if (l === null || l === undefined) {
        return
      }
      let tmp = []
      let x, y, radius
      for (let i = 0; i < l.length; i++) {
        x = l[i].x ? this.realToCanvas(l[i].x) : 0
        y = l[i].y ? this.realToCanvas(l[i].y) : 0
        radius = l[i].radius ? this.realToCanvas(l[i].radius) : 0
        tmp.push(this.$draw.toCurveArea(x, y, radius, l[i].startAngle, l[i].fillAngle, l[i].lineColor, l[i].fillColor, l[i].lineWidth))
      }
      return tmp
    },
    rectp2c (l) {
      if (l === null || l === undefined) {
        return
      }
      let tmp = []
      let x, y, width, height
      for (let i = 0; i < l.length; i++) {
        x = l[i].x ? this.realToCanvas(l[i].x) : 0
        y = l[i].y ? this.realToCanvas(l[i].y) : 0
        width = l[i].width ? this.realToCanvas(l[i].width) : 0
        height = l[i].height ? this.realToCanvas(l[i].height) : 0
        tmp.push(this.$draw.toRectArea(x, y, width, height, l[i].lineColor, l[i].fillColor, l[i].lineWidth))
      }
      return tmp
    },
    ap2c (p) {
      if (p === null || p === undefined) {
        return
      }
      let tmp = []
      let x, y
      for (let i = 0; i < p.length; i++) {
        let ps = []
        for (let j = 0; j < p[i].length; j++) {
          x = p[i][j].x ? this.realToCanvas(p[i][j].x) : 0
          y = p[i][j].y ? this.realToCanvas(p[i][j].y) : 0
          ps.push(this.$draw.toPoint(x, y))
        }
        tmp.push(ps)
      }
      return tmp
    },
    p2c (p) {
      if (p === null || p === undefined) {
        return
      }
      let tmp = []
      let x, y
      for (let i = 0; i < p.length; i++) {
        x = p[i].x ? this.realToCanvas(p[i].x) : 0
        y = p[i].y ? this.realToCanvas(p[i].y) : 0
        tmp.push(this.$draw.toPoint(x, y))
      }

      return tmp
    },
    t2c (t) {
      let tmp = []
      let x, y
      for (let i = 0; i < t.length; i++) {
        x = t[i].x ? this.realToCanvas(t[i].x) : 0
        y = t[i].y ? this.realToCanvas(t[i].y) : 0
        tmp.push(this.$draw.toText(x, y, t[i].text))
      }

      return tmp
    },
    ars2c (t) {
      let tmp = []
      let x, y
      if (t) {
        for (let i = 0; i < t.length; i++) {
          let ps = []
          for (let j = 0; j < t[i].length; j++) {
            x = t[i][j].x ? this.realToCanvas(t[i][j].x) : 0
            y = t[i][j].y ? this.realToCanvas(t[i][j].y) : 0
            ps.push(this.$draw.toPoint(x, y))
          }
          tmp.push(ps)
        }
      }

      return tmp
    },
    canvasToReal (data) {
      return data * this.proportion
    },
    realToCanvas (data) {
      return data / this.proportion
    },
    resizeDraw () {
      this.refreshCv()
      this.refreshData()
      this.drawCv()
    },
    refreshData () {
      this.pjRectToCanvas()
      this.roomRectToCanvas()
      this.avlRectToCanvas()
      this.arrRectLinesToCanvas()
      this.arrLightingAreaToCanvas()
      this.arrCatchAreaToCanvas()
      this.arrBlackAreaToCanvas()
      this.arrDashLinesToCanvas()
      this.arrDashRemainLinesToCanvas()
      this.arrOffsetLinesToCanvas()
      this.arrHelpLinesToCanvas()
      this.arrHelpTextToCanvas()
      this.arrRectHorSecLinesToCanvas()
      this.arrowRectsToCanvas()
      this.arrCurveRectToCanvas()
      this.arrRectAreaToCanvas()
    },
    pjRectToCanvas () {
      let x = this.realToCanvas(this.pjRect.x) - this.pjRect.width / 2
      let y = this.realToCanvas(this.pjRect.y) - this.pjRect.height / 2
      return this.$draw.toRect(x, y, this.pjRect.width, this.pjRect.height)
    },
    roomRectToCanvas () {
      return this.r2c(this.roomRect)
    },
    avlRectToCanvas () {
      if (this.$commonViewJs.isAvlExist() || this.avlRect) {
        if (this.id === 'frontView') {
          return this.p2c(this.avlRect)
        } else {
          return this.r2c(this.avlRect)
        }
      }
    },
    arrRectLinesToCanvas () {
      return this.l2c(this.arrRectLines)
    },
    arrLightingAreaToCanvas () {
      return this.ap2c(this.arrLightingArea)
    },
    arrCatchAreaToCanvas () {
      return this.p2c(this.arrCatchArea)
    },
    arrBlackAreaToCanvas () {
      if (this.arrBlackArea) {
        return this.p2c(this.arrBlackArea)
      }
    },
    arrDashLinesToCanvas () {
      return this.l2c(this.arrDashLines)
    },
    arrDashRemainLinesToCanvas () {
      return this.l2c(this.arrDashRemainLines)
    },
    arrOffsetLinesToCanvas () {
      return this.l2c(this.arrOffsetLines)
    },
    arrHelpLinesToCanvas () {
      return this.l2c(this.arrHelpLines)
    },
    arrQuickCornerLinesToCanvas () {
      return this.l2c(this.arrQuickCornerLines)
    },
    arrCornerCorAreasToCanvas () {
      return this.ars2c(this.arrCornerCorAreas)
    },
    arrHelpTextToCanvas () {
      return this.t2c(this.arrHelpText)
    },
    arrRectHorSecLinesToCanvas () {
      return this.l2c(this.arrRectHorSecLines)
    },
    arrowRectsToCanvas () {
      return this.arp2c(this.arrowRects)
    },
    arrCurveRectToCanvas () {
      return this.canp2c(this.arrCurveRect)
    },
    arrRectAreaToCanvas () {
      return this.rectp2c(this.arrRectArea)
    }
  },

  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeyDown, false)
    window.removeEventListener('keyup', this.handelKeyUp, false)
  }
}
</script>

<style scoped>
canvas {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/cv.vue